export const isRouteChanged = title => action => (
  action.type === 'ROUTER_LOCATION_CHANGED'
  && action.payload
  && action.payload.result
  && action.payload.result.title === title
)

export const routeNotDefined = action => (
  action.type === 'ROUTER_LOCATION_CHANGED'
  && (!action.payload || !action.payload.result)
)

export const isBlur = (form, field) => action =>
  action.type === '@@redux-form/BLUR' &&
  action.meta.form === form &&
  action.meta.field === field
